const credentials = [
  {
    icon: 'ri-shield-star-line',
    label: 'EPA / OSHA Certified',
    sub: 'Full Regulatory Compliance',
    stat: '',
  },
  {
    icon: 'ri-award-line',
    label: 'Licensed & Insured',
    sub: 'Commercial · Industrial · Gov.',
    stat: '',
  },
  {
    icon: 'ri-alarm-warning-line',
    label: '24/7 Emergency',
    sub: 'Rapid Response Available',
    stat: '',
  },
  {
    icon: 'ri-map-pin-2-line',
    label: 'Trusted Across Colorado',
    sub: 'Springs · Denver · Pueblo · Front Range',
    stat: '',
  },
  {
    icon: 'ri-star-fill',
    label: '4.9 / 5 Rating',
    sub: '200+ Verified Reviews',
    stat: '',
  },
];

export default function TrustBar() {
  return (
    <div className="bg-ecos-charcoal-mid border-y border-white/8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-5 divide-x divide-white/8">
          {credentials.map((item, idx) => (
            <div
              key={item.label}
              className={`flex flex-col items-center text-center py-7 px-4 ${idx >= 4 ? 'col-span-2 lg:col-span-1' : ''}`}
            >
              <div className="w-9 h-9 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-xl text-ecos-green`}></i>
              </div>
              <p className="text-white text-sm font-semibold tracking-wide leading-tight">{item.label}</p>
              <p className="text-white/45 text-xs mt-1.5 leading-snug">{item.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
